import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';

import { urlEndPoints } from '../config/end-points';
import { RoomInterventionEstimate } from '../models/intervention-estimate.model';
import { Room } from '../models/room.model';
@Injectable({
  providedIn: 'root',
})
export class PythonAPIDal {
  constructor(private httpClient: HttpClient) {}

  autoFillingByInterval(
    startDate: string,
    endDate: string,
    roomsToKeep: any[],
    roomsConfiguration: any,
    autofillingType?: string,
    population?: string,
    allowInterServiceMobility?: boolean,
    hospitals?: string[],
    sourceHospitals?: string[],
    roomsToMaintain?: string[],
    formationsGroupId?: string
  ): Observable<any[]> {
    return this.httpClient.post<Room[]>(
      `${urlEndPoints.pythonAPI}autoFillingByInterval?startDate=${startDate}&endDate=${endDate}`,
      {
        roomsToKeep,
        roomsConfiguration,
        autofillingType,
        population,
        allowInterServiceMobility,
        hospitals,
        sourceHospitals,
        roomsToMaintain,
        formationsGroupId,
      }
    );
  }

  autoFillingByIntervalAnesth(
    startDate: string,
    endDate: string,
    seniority?: any,
    autofillingTypes?: any,
    roomsToKeep?: any[],
    isSplitTeams?: boolean,
    hospitals?: string[],
    formationsGroupId?: string
  ): Observable<any[]> {
    return this.httpClient.post<Room[]>(
      `${urlEndPoints.pythonAPI}autoFillingByIntervalAnesth?startDate=${startDate}&endDate=${endDate}`,
      { roomsToKeep, seniority, isSplitTeams, autofillingTypes, hospitals, formationsGroupId }
    );
  }

  getRanking(
    date: string,
    surgeonopenings: any,
    roles: any,
    programs: any,
    formationsGroups: any,
    autofillingTypes: string[],
    consultExtraData: any,
    blocNeeds: any
  ): Observable<any> {
    const body = {
      surgeonopenings,
      roles,
      programs,
      formationsGroups,
      autofillingTypes,
      consultExtraData,
      blocNeeds,
    };
    return this.httpClient.post<any>(`${urlEndPoints.pythonAPI}ranks?date=${date}`, body);
  }

  // getAnesthsRanking(date: string): Observable<anesthsRanks> {
  //   return this.httpClient.get<anesthsRanks>(`${urlEndPoints.pythonAPI}ranksAnesth?date=${date}`);
  // }

  getRoomsOverflowData(date: string, displayReal: boolean = false): Observable<any[]> {
    return this.httpClient.get<any[]>(`${urlEndPoints.pythonAPI}roomsOverflow?date=${date}&displayReal=${displayReal}`);
  }

  getInterventionOverflowData(doctorAgendasId: string): Observable<any[]> {
    return this.httpClient.get<any[]>(
      urlEndPoints.pythonAPI + 'interventionOverflow?&doctorAgendasId=' + doctorAgendasId
    );
  }

  getRoomsOverflowOfUnsavedData(date: string, roomsWithDoctorAgendas: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      urlEndPoints.pythonAPI + 'roomsOverflowOfUnsavedData?date=' + date,
      roomsWithDoctorAgendas
    );
  }

  getSurgeonOpeningsOfSurgeonByInterval(surgeonId: string, startDate: string, endDate: string): Observable<any[]> {
    return this.httpClient.get<any>(
      `${urlEndPoints.pythonAPI}bySurgeonAndInterval/${surgeonId}?startDate=${startDate}&endDate=${endDate}`
    );
  }

  getInterventionEstimates(date: string): Observable<RoomInterventionEstimate[]> {
    return this.httpClient.get<RoomInterventionEstimate[]>(
      `${urlEndPoints.pythonAPI}interventionEstimates?date=${date}`
    );
  }

  adjustPlanning(planningConfigId: string): Observable<any[]> {
    return this.httpClient.post<Room[]>(`${urlEndPoints.pythonAPI}adjustPlanning`, { planningConfigId });
  }
}
